import store from './index'

export default {
  initFromStorage (state, opt) {
    for (const i in opt) {
      state[i] = opt[i]
    }
  },
  setSessionToken (state, sessionToken) {
    state.sessionToken = sessionToken
  },
  setUser (state, user) {
    state.user = user
    // 当用户登录时加载我的课程列表
    if (user) {
      store.dispatch('fetchMyCourses')
    } else {
      // 用户退出登录时清空列表
      state.myCourseIds = []
    }
  },
  setProgress (state, progress) {
    state.isRecordProgress = progress
  },
  setShowExchange (state, showExchange) {
    state.isShowExchange = showExchange
  },
  setMyCourseIds (state, courseIds) {
    state.myCourseIds = courseIds
  },
  setCurrentQuiz (state, quiz) {
    state.currentQuiz = quiz
  },
  setQuizResult (state, result) {
    state.quizResult = result
  }
}
